import { useEffect } from "react";
import {
  Stack,
  Typography,
  IconButton,
  Button,
  Paper,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
  Menu,
  MenuItem,
  ListSubheader,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import MultiSearchFilter from "LTCP Module/components/MultiSearchFilter";
import { LTCPContext } from "LTCP Module/LTCPContext";
import ReactECharts from "echarts-for-react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import {
  getSimulationFilters,
  getSimulationLineSpeed,
  getSimulationLineSpeedOR,
} from "LTCP Module/api/ltcpBackend";
import DemandCapacityGraph from "LTCP Module/components/DemandCapacityGraph";
import SearchFilter from "LTCP Module/components/SearchFilter";
import { useMsal } from "@azure/msal-react";
import { roundOffNumber } from "utils/roundOff";

const MONTH_NAME = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const TableHeaderCell = styled(TableCell)({
  fontWeight: "bold",
  background: "#354acd",
  color:"#FFFFFF",
  py: 0,
  fontSize: 12,
});

const TableDataCell = styled(TableCell)({
  fontSize: 12,
  textWrap: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  borderBottom: "1px solid #ccc",
});

// This is a stateless table cell commponent that is used to edit and show
// values in table cell. On any change event it will call the given state
// set function and will update the state in the parent component.
function TableEditBox({ rowSpan, value, onChange, readOnly,sx ={} }) {
  return (
    <TableDataCell rowSpan={rowSpan} sx={{ p: 0, background: "#e3e6f5",...sx }}>
      <input
        type="number"
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        style={{
          border: "none",
          background: "none",
          width: "100%",
          height: "100%",
          outline: "none",
          textAlign: "center",
          boxSizing: "border-box",
          fontSize: 12,
        }}
      />
    </TableDataCell>
  );
}

// This is the simulation table row component that contain all the logics
// and based the the business rule it update the current and all the other
// related rows when user modify the BCT or line speed or line OEE.
function ScenarioRow({
  item,
  format,
  allData,
  setAllData,
  readOnly,
  currentProductType,
  selectedColumns,
  isMakes
}) {
  const productType = currentProductType;

  let activerow = format === item.formatsl2;
  let background = activerow ? "#b4bfff" : "none";

  let tmpSplit = item.capacitymonth.split("-");
  let month = Number.parseInt(tmpSplit[0]);
  let monthName = MONTH_NAME[month - 1] + "-" + tmpSplit[1];
  let hasMakeShiftsValue = item.makeshifts > 0;
  console.log('items value: ',item);

  function changeBCT(val) {
    let newData = [...allData];

    for (let i = 0; i < allData.length; i++) {
      let thisRow = allData[i];

      const rowMatched =
        thisRow.brand === item.brand &&
        thisRow.formatsl1 === item.formatsl1 &&
        thisRow.mixerno === item.mixerno &&
        thisRow.cascadeno === item.cascadeno &&
        thisRow.brandvariant === item.brandvariant;

      if (!rowMatched) continue;

      let makecap =
        (480 / val) *
        thisRow.batchsize *
        thisRow.makeshifts *
        (thisRow.ope / 100);
      let act_capacity = Math.min(makecap, thisRow.group_sum);

      // if (productType === "HC_LIQUIDS") {
      //   act_capacity = thisRow.group_sum;
      // }

      newData[i].bct = val;
      newData[i].makecapacitytpw = makecap;
      newData[i].act_capacity = act_capacity;
      newData[i].act_pack_cap =
        (thisRow.capacitytpw * act_capacity) / thisRow.group_sum || 0;

      // if (productType === "HC_LIQUIDS") {
      //   newData[i].act_pack_cap = thisRow.capacitytpw;
      // }
    }

    setAllData(newData);
  }

  function changeLineSpeed(val) {
    let newData = [...allData];

    for (let i = 0; i < allData.length; i++) {
      let thisRow = allData[i];

      const rowMatched =
        thisRow.brand === item.brand &&
        thisRow.formatsl1 === item.formatsl1 &&
        thisRow.mixerno === item.mixerno &&
        thisRow.cascadeno === item.cascadeno &&
        thisRow.brandvariant === item.brandvariant &&
        thisRow.basepackdescription === item.basepackdescription &&
        thisRow.uniqueline === item.uniqueline;

      if (!rowMatched) continue;

      let capacitytpw =
        thisRow.packshifts *
        thisRow.grammage *
        thisRow.nooflines *
        val *
        thisRow.lineoee *
        (480 / Math.pow(10, 8));

      let group_sum = thisRow.group_sum - thisRow.capacitytpw + capacitytpw;
      let act_capacity = Math.min(thisRow.makecapacitytpw, group_sum);

      // if (productType === "HC_LIQUIDS") {
      //   act_capacity = group_sum;
      // }

      newData[i].linespeed = val;
      newData[i].capacitytpw = capacitytpw;

      for (let j = 0; j < newData.length; j++) {
        let tmpRow = newData[j];

        if (
          tmpRow.brand === thisRow.brand &&
          tmpRow.formatsl1 === thisRow.formatsl1 &&
          tmpRow.brandvariant === thisRow.brandvariant &&
          tmpRow.cascadeno == thisRow.cascadeno &&
          tmpRow.mixerno === thisRow.mixerno
        ) {
          newData[i].group_sum = group_sum;
          newData[i].act_capacity = act_capacity;
           if(!item.makeshifts && item.makeshifts <= 0){
             newData[i].act_pack_cap  = newData[i].capacitytpw;
          }
           else {
             newData[i].act_pack_cap = (thisRow.capacitytpw * act_capacity) / thisRow.group_sum || 0;
          }

          // if (productType === "HC_LIQUIDS") {
          //   newData[i].act_pack_cap = newData[i].capacitytpw;
          // }
        }
      }
    }

    setAllData(newData);
  }

  function changeLineOee(val) {
    let newData = [...allData];

    for (let i = 0; i < allData.length; i++) {
      let thisRow = allData[i];

      const rowMatched =
        thisRow.brand === item.brand &&
        thisRow.formatsl1 === item.formatsl1 &&
        thisRow.mixerno === item.mixerno &&
        thisRow.cascadeno === item.cascadeno &&
        thisRow.brandvariant === item.brandvariant &&
        thisRow.basepackdescription === item.basepackdescription &&
        thisRow.uniqueline === item.uniqueline;

      if (!rowMatched) continue;

      let capacitytpw =
        thisRow.packshifts *
        thisRow.grammage *
        thisRow.nooflines *
        thisRow.linespeed *
        val *
        (480 / Math.pow(10, 8));

      let group_sum = thisRow.group_sum - thisRow.capacitytpw + capacitytpw;
      let act_capacity = Math.min(thisRow.makecapacitytpw, group_sum);

      // if (productType === "HC_LIQUIDS") {
      //   act_capacity = group_sum;
      // }

      newData[i].lineoee = val;
      newData[i].capacitytpw = capacitytpw;

      for (let j = 0; j < newData.length; j++) {
        let tmpRow = newData[j];

        if (
          tmpRow.brand === thisRow.brand &&
          tmpRow.formatsl1 === thisRow.formatsl1 &&
          tmpRow.brandvariant === thisRow.brandvariant &&
          tmpRow.cascadeno == thisRow.cascadeno &&
          tmpRow.mixerno === thisRow.mixerno
        ) {
          newData[i].group_sum = group_sum;
          newData[i].act_capacity = act_capacity;
           if(!item.makeshifts && item.makeshifts <= 0){
             newData[i].act_pack_cap  = newData[i].capacitytpw;
          }
           else {
             newData[i].act_pack_cap = (thisRow.capacitytpw * act_capacity) / thisRow.group_sum || 0;
          }

          // if (productType === "HC_LIQUIDS") {
          //   newData[i].act_pack_cap = newData[i].capacitytpw;
          // }
        }
      }
    }

    setAllData(newData);
  }

  return (
    <TableRow>
      {selectedColumns.factory && (
        <TableDataCell sx={{ background }}>{item.factoryname}</TableDataCell>
      )}
      {selectedColumns.brandvariant && (
        <TableDataCell sx={{ background }}>{item.brandvariant}</TableDataCell>
      )}
      {selectedColumns.format && (
        <TableDataCell sx={{ background }}>{item.formatsl2}</TableDataCell>
      )}
      {selectedColumns.basepack && (
        <TableDataCell sx={{ background }}>
          {item.basepackdescription}
        </TableDataCell>
      )}
      {isMakes && selectedColumns.cascade && (
        <TableDataCell sx={{ background }}>{item.cascadeno}</TableDataCell>
      )}
      {isMakes && selectedColumns.mixer && (
        <TableDataCell sx={{ background }}>{item.mixerno}</TableDataCell>
      )}
      {item.key_count > 0 && (
        <>
          {isMakes && selectedColumns.makeshift && (
            <TableDataCell
              rowSpan={item.key_count}
              sx={{ textAlign: "center" }}
            >
              {item.makeshifts}
            </TableDataCell>
          )}
          {isMakes && selectedColumns.batchsize && (
            <TableDataCell
              rowSpan={item.key_count}
              sx={{ textAlign: "center" }}
            >
              {item.batchsize}
            </TableDataCell>
          )}
          {isMakes && selectedColumns.bct && (
            <TableEditBox
              rowSpan={item.key_count}
              sx={{ textAlign: "center",background : (!hasMakeShiftsValue || readOnly) ? "transparent": "#e3e6f5"}}
              value={item.bct}
              readOnly= {!hasMakeShiftsValue || readOnly}
              onChange={(e) => changeBCT(e.target.value)}
            />
          )}
          {isMakes && selectedColumns.benchmarkbct && (
            <TableDataCell
              rowSpan={item.key_count}
              sx={{ textAlign: "center" }}
            >
              {item.benchmarkbct}
            </TableDataCell>
          )}
          {isMakes && selectedColumns.makecap && (
            <TableDataCell
              rowSpan={item.key_count}
              sx={{ textAlign: "center" }}
            >
              {roundOffNumber(item.makecapacitytpw)}
            </TableDataCell>
          )}
        </>
      )}
      {selectedColumns.machine && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {item.machine}
        </TableDataCell>
      )}
      {selectedColumns.uniqueline && (
        <TableDataCell sx={{ background }}>{item.uniqueline}</TableDataCell>
      )}
      {selectedColumns.packshift && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {item.packshifts}
        </TableDataCell>
      )}
      {selectedColumns.grammage && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {item.grammage}
        </TableDataCell>
      )}
      {selectedColumns.linespeed && (
        <TableEditBox
          value={item.linespeed}
          readOnly={readOnly}
          onChange={(e) => changeLineSpeed(e.target.value)}
        />
      )}
      {selectedColumns.benchmarklinespeed && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {item.benchmarklinespeed}
        </TableDataCell>
      )}
      {selectedColumns.lineoee && (
        <TableEditBox
          value={item.lineoee}
          readOnly={readOnly}
          onChange={(e) => changeLineOee(e.target.value)}
        />
      )}
      {selectedColumns.benchmarklineoee && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {item.benchmarklineoee}
        </TableDataCell>
      )}
      {selectedColumns.packcap && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {roundOffNumber(item.capacitytpw)}
        </TableDataCell>
      )}
      {isMakes &&
        selectedColumns.actcap &&
        item.key_count > 0 && (
          <TableDataCell rowSpan={item.key_count} sx={{ textAlign: "center" }}>
            {roundOffNumber(item.act_capacity)}
          </TableDataCell>
        )}
      {selectedColumns.actpackcap && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {roundOffNumber(item.act_pack_cap)}
        </TableDataCell>
      )}
      {selectedColumns.month && (
        <TableDataCell sx={{ background, textAlign: "center" }}>
          {monthName}
        </TableDataCell>
      )}
    </TableRow>
  );
}

// This is a scenario simulation tab template where it's using the scenario
// row component for instant simulation. It also contain the column selection
// feature which will help the user to show or hide any specific column
// according to their need. Finally after modifing the values in the table
// user can save the data for comparison.
function Scenario({
  name,
  factory,
  orValue,
  allData,
  setAllData,
  graphData,
  setGraphData,
  currentProductType,
  readOnly,
  runType
}) {
  function getCurrentMonthYear() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${month}-${year}`;
  }
  function checkMakesOrNot(){
    return allData.every(
      row => row.cascadeno && row.cascadeno.trim().toLowerCase() !== "none" && row.mixerno && row.mixerno.trim().toLowerCase() !== "none"
    );
  }
   const isMakes = runType.toLowerCase() === 'manual' ? checkMakesOrNot(): true;
   const currentMonth = getCurrentMonthYear();

  const [formatState, setFormatState] = useState("All");
  const [columnSelector, setColumnSelector] = useState(null);
  const [selectAll, setSelectAll] = useState(true);
  const [selectedColumns, setSelectedColumns] = useState({
    factory: true,
    brandvariant: true,
    format: true,
    basepack: true,
    cascade: true,
    mixer: true,
    makeshift: true,
    batchsize: true,
    bct: true,
    benchmarkbct: true,
    makecap: true,
    machine: true,
    uniqueline: true,
    packshift: true,
    grammage: true,
    linespeed: true,
    benchmarklinespeed: true,
    lineoee: true,
    benchmarklineoee: true,
    packcap: true,
    actcap: true,
    actpackcap: true,
    month: false,
  });
 

  function ColumnSelector({ name, title }) {
    return (
      <MenuItem
        onClick={() => {
          setSelectedColumns({
            ...selectedColumns,
            [name]: !selectedColumns[name],
          });
        }}
      >
        {selectedColumns[name] ? (
          <CheckBoxIcon sx={{ mr: 1, fontSize: 18, color: "blue" }} />
        ) : (
          <CheckBoxOutlineBlankIcon
            sx={{ mr: 1, fontSize: 18, color: "#888" }}
          />
        )}
        {title}
      </MenuItem>
    );
  }

  useEffect(() => {
    setFormatState("All");
  }, [factory]);

  useEffect(() => {
    const group = allData
      .filter((item) => formatState === "All" || item.formatsl2 === formatState)
      .reduce((acc, curr) => {
        const key = curr.capacitymonth + curr.demand;

        if (!acc[key]) {
          acc[key] = {
            label: curr.capacitymonth,
            demand: curr.demand,
            capacity: 0,
          };
        }

        acc[key].capacity += curr.act_pack_cap;

        return acc;
      }, {});

    let group_data = Object.values(group).reduce((acc, curr) => {
      const key = curr.label;

      if (!acc[key]) {
        acc[key] = { label: key, demand: 0, capacity: 0 };
      }

      acc[key].demand += curr.demand;
      acc[key].capacity += curr.capacity;

      return acc;
    }, {});

    group_data = Object.values(group_data)
      .map((item) => {
        let tmpSplit = item.label.split("-");

        let month = Number.parseInt(tmpSplit[0]);
        month = MONTH_NAME[month - 1];

        return {
          date: tmpSplit[1] + "-" + tmpSplit[0],
          label: month + "-" + tmpSplit[1],
          demand: roundOffNumber(item.demand),
          capacity: roundOffNumber(item.capacity * 4.17),
          cu:
            roundOffNumber(
              (item.demand / (item.capacity * 4.17 * (orValue / 100))) * 100
            ) || 0,
        };
      })
      .sort((a, b) => a.date.localeCompare(b.date));

    setGraphData(group_data);
  }, [formatState, allData]);

  return (
    <Stack gap={2}>
      <Paper sx={{ height: "calc(50vh - 150px)" }}>
        <Stack p={2} py={0.5} gap={0.5} height="100%">
          <Stack
            height={26}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight="bold" fontSize={14}>
              Line Speed/OEE Increase - Simulation
            </Typography>
            <IconButton
              size="small"
              onClick={(e) => setColumnSelector(e.currentTarget)}
            >
              <BorderAllIcon sx={{ fontSize: 12 }} />
            </IconButton>
          </Stack>
          <Menu
            open={Boolean(columnSelector)}
            onClose={() => setColumnSelector(null)}
            anchorEl={columnSelector}
          >
            <ListSubheader>Select Columns</ListSubheader>
            <MenuItem
              onClick={() => {
                if (selectAll)
                  setSelectedColumns({
                    factory: true,
                    brandvariant: true,
                    format: true,
                    basepack: true,
                    cascade: true,
                    mixer: true,
                    makeshift: true,
                    batchsize: true,
                    bct: true,
                    benchmarkbct: true,
                    makecap: true,
                    machine: true,
                    uniqueline: true,
                    packshift: true,
                    grammage: true,
                    linespeed: true,
                    benchmarklinespeed: true,
                    lineoee: true,
                    benchmarklineoee: true,
                    packcap: true,
                    actcap: true,
                    actpackcap: true,
                    month: true,
                  });
                else
                  setSelectedColumns({
                    factory: false,
                    brandvariant: false,
                    format: false,
                    basepack: false,
                    cascade: false,
                    mixer: false,
                    makeshift: false,
                    batchsize: false,
                    bct: false,
                    benchmarkbct: false,
                    makecap: false,
                    machine: false,
                    uniqueline: false,
                    packshift: false,
                    grammage: false,
                    linespeed: false,
                    benchmarklinespeed: false,
                    lineoee: false,
                    benchmarklineoee: false,
                    packcap: false,
                    actcap: false,
                    actpackcap: false,
                    month: false,
                  });
                setSelectAll(!selectAll);
              }}
            >
              {selectAll ? (
                <CheckBoxOutlineBlankIcon
                  sx={{ mr: 1, fontSize: 18, color: "#888" }}
                />
              ) : (
                <CheckBoxIcon sx={{ mr: 1, fontSize: 18, color: "blue" }} />
              )}
              Select All
            </MenuItem>
            <ColumnSelector name="factory" title="Factory" />
            <ColumnSelector name="brandvariant" title="Brand Variant" />
            <ColumnSelector name="format" title="Formats L2" />
            <ColumnSelector name="basepack" title="Basepack Description" />
            {isMakes && (
              <>
                <ColumnSelector name="cascade" title="Cascade No" />
                <ColumnSelector name="mixer" title="Mixer No" />
                <ColumnSelector name="makeshift" title="Make Shifts" />
                <ColumnSelector name="batchsize" title="Batch Size" />
                <ColumnSelector name="bct" title="BCT" />
                <ColumnSelector name="benchmarkbct" title="Benchmark BCT" />
                <ColumnSelector name="makecap" title="Make Cap (tpw)" />
              </>
            )}
            <ColumnSelector name="machine" title="Machine" />
            <ColumnSelector name="uniqueline" title="Unique Line" />
            <ColumnSelector name="packshift" title="Pack Shifts" />
            <ColumnSelector name="grammage" title="Grammage" />
            <ColumnSelector name="linespeed" title="Line Speed" />
            <ColumnSelector
              name="benchmarklinespeed"
              title="Benchmark Line Speed"
            />
            <ColumnSelector name="lineoee" title="Line OEE %" />
            <ColumnSelector
              name="benchmarklineoee"
              title="Benchmark Line OEE"
            />
            <ColumnSelector name="packcap" title="Pack Cap (tpw)" />
            {isMakes && (
              <ColumnSelector
                name="actcap"
                title="Act Capacity (Min of Make & Pack)"
              />
            )}
            <ColumnSelector name="actpackcap" title="Act Pack Cap (tpw)" />
            <ColumnSelector name="month" title="Month" />
          </Menu>
          <Box sx={{ display: "flex", height: "calc(98% - 30px)" }}>
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {selectedColumns.factory && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Factory
                      </TableHeaderCell>
                    )}
                    {selectedColumns.brandvariant && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Brand Variant
                      </TableHeaderCell>
                    )}
                    {selectedColumns.format && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Formats L2
                      </TableHeaderCell>
                    )}
                    {selectedColumns.basepack && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Basepack Description
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.cascade && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Cascade No
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.mixer && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Mixer No
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.makeshift && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Make Shifts
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.batchsize && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Batch Size
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.bct && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        BCT
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.benchmarkbct && (
                      <TableHeaderCell
                        sx={{ textWrap: "nowrap", background: "#00b190" }}
                      >
                        Benchmark BCT
                      </TableHeaderCell>
                    )}
                    {isMakes && selectedColumns.makecap && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Make Cap (tpw)
                      </TableHeaderCell>
                    )}
                    {selectedColumns.machine && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Machine
                      </TableHeaderCell>
                    )}
                    {selectedColumns.uniqueline && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Unique Line
                      </TableHeaderCell>
                    )}
                    {selectedColumns.packshift && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Pack Shifts
                      </TableHeaderCell>
                    )}
                    {selectedColumns.grammage && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Grammage
                      </TableHeaderCell>
                    )}
                    {selectedColumns.linespeed && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Line Speed
                      </TableHeaderCell>
                    )}
                    {selectedColumns.benchmarklinespeed && (
                      <TableHeaderCell
                        sx={{ textWrap: "nowrap", background: "#00b190" }}
                      >
                        Benchmark Line Speed
                      </TableHeaderCell>
                    )}
                    {selectedColumns.lineoee && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Line OEE %
                      </TableHeaderCell>
                    )}
                    {selectedColumns.benchmarklineoee && (
                      <TableHeaderCell
                        sx={{ textWrap: "nowrap", background: "#00b190" }}
                      >
                        Benchmark Line OEE
                      </TableHeaderCell>
                    )}
                    {selectedColumns.packcap && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Pack Cap (tpw)
                      </TableHeaderCell>
                    )}
                    {isMakes &&
                      selectedColumns.actcap && (
                        <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                          Act Capacity (Min of Make & Pack)
                        </TableHeaderCell>
                      )}
                    {selectedColumns.actpackcap && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Act Pack Cap (tpw)
                      </TableHeaderCell>
                    )}
                    {selectedColumns.month && (
                      <TableHeaderCell sx={{ textWrap: "nowrap" }}>
                        Month
                      </TableHeaderCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {allData
                    .filter((item) => item.capacitymonth === currentMonth)
                    .map((item, index) => (
                      <ScenarioRow
                        key={name + index}
                        currentIndex={index}
                        item={item}
                        allData={allData}
                        setAllData={setAllData}
                        readOnly={readOnly}
                        currentProductType={currentProductType}
                        selectedColumns={selectedColumns}
                        isMakes = {isMakes}
                      />
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Stack>
      </Paper>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "calc(50vh - 130px)",
          pb: 1,
        }}
      >
        <Stack
          p={1}
          gap={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Typography>Demand Vs Capacity</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: 200,
              alignItems: "stretch",
            }}
          >
            <SearchFilter
              all
              width
              value={formatState}
              setValue={setFormatState}
              options={[...new Set(allData.map((item) => item.formatsl2))]}
            />
          </Box>
        </Stack>
        <Box sx={{ flexGrow: 1 }}>
          <DemandCapacityGraph
            labelBg
            labels={graphData.map((item) => item.label)}
            demand={graphData.map((item) => item.demand)}
            capacity={graphData.map((item) => item.capacity)}
            cu={graphData.map((item) => item.cu)}
          />
        </Box>
      </Paper>
    </Stack>
  );
}

// This page will collect the final data from all three tabes which user has
// modified and saved. It also contain it's own format filter but for this page
// factory filter is disable to prevent cross factory data to be saved for
// comparison.
function ScenarioComparison({ s1Data, s2Data, s3Data, originalData, orValue }) {
  const { setLoading } = useContext(LTCPContext);

  const [aggData, setAggData] = useState([]);
  const [formatState, setFormatState] = useState("");
  const [formatOptions, setFormatOptions] = useState([]);

  function calculateCu(demand, capacity) {
    if (capacity === 0) return 0;

    return roundOffNumber((demand / (capacity * (orValue / 100))) * 100);
  }

  useEffect(() => {
    setLoading(true);
    const joinedData = originalData.map((item, index) => {
      return {
        format: item.formatsl2,
        month: item.capacitymonth,
        demand: item.demand,
        basepack: item.basepackdescription,
        cap: item.act_pack_cap,
        cap1: s1Data[index]?.act_pack_cap || 0,
        cap2: s2Data[index]?.act_pack_cap || 0,
        cap3: s3Data[index]?.act_pack_cap || 0,
      };
    });

    let groupData = joinedData.reduce((acc, curr) => {
      const key = curr.demand + curr.format + curr.month + curr.basepack;

      if (!acc[key]) {
        acc[key] = {
          format: curr.format,
          month: curr.month,
          demand: curr.demand,
          cap: 0,
          cap1: 0,
          cap2: 0,
          cap3: 0,
        };
      }

      acc[key].cap += curr.cap;
      acc[key].cap1 += curr.cap1;
      acc[key].cap2 += curr.cap2;
      acc[key].cap3 += curr.cap3;

      return acc;
    }, {});

    groupData = Object.values(groupData);

    groupData = groupData.reduce((acc, curr) => {
      const key = curr.format + curr.month;

      if (!acc[key]) {
        acc[key] = {
          format: curr.format,
          month: curr.month,
          demand: 0,
          cap: 0,
          cap1: 0,
          cap2: 0,
          cap3: 0,
        };
      }

      acc[key].demand += curr.demand;
      acc[key].cap += curr.cap;
      acc[key].cap1 += curr.cap1;
      acc[key].cap2 += curr.cap2;
      acc[key].cap3 += curr.cap3;

      return acc;
    }, {});

    groupData = Object.values(groupData)
      .map((item) => {
        let monthName = item.month.split("-");

        item.date = monthName[1] + "-" + monthName[0];

        item.month =
          MONTH_NAME[Number.parseInt(monthName[0]) - 1] + "-" + monthName[1];

        item.cap *= 4.17;
        item.cap1 *= 4.17;
        item.cap2 *= 4.17;
        item.cap3 *= 4.17;

        return item;
      })
      .sort((a, b) => a.date.localeCompare(b.date));

    setFormatState(joinedData[0].format);
    setFormatOptions([...new Set(joinedData.map((item) => item.format))]);
    setAggData(groupData);
    setLoading(false);
  }, [s1Data, s2Data, s3Data, originalData]);

  const option = {
    grid: {
      top: 10,
      left: 80,
      right: 50,
      bottom: 50,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    xAxis: [
      {
        type: "category",
        data: aggData
          .filter((item) => item.format === formatState)
          .map((item) => item.month),
        axisPointer: {
          type: "shadow",
        },
        axisLabel: {
          textStyle: {
            fontSize: 10,
          },
        },
      },
    ],
    legend: {
      data: [
        "Original Capacity (T)",
        "Capacity 1 (T)",
        "Capacity 2 (T)",
        "Capacity 3 (T)",
      ],
      top: "bottom",
      textStyle: {
        fontSize: 11,
      },
      icon:"rect",
      itemWidth: 6,
      itemHeight: 15,
    },
    yAxis: [
      {
        type: "value",
        name: "Tonnes",
        nameLocation: "middle",
        nameGap: 50,
        nameRotate: 90,
        axisLabel: {
          formatter: "{value}",
          textStyle: {
            fontSize: 10,
          },
        },
      },
    ],
    series: [
      {
        name: "Original Capacity (T)",
        type: "line",
        yAxisIndex: 0,
        tooltip: {
          valueFormatter: function (value) {
            return value;
          },
        },
        data: aggData
          .filter((item) => item.format === formatState)
          .map((item) => roundOffNumber(item.cap)),
        itemStyle: {
          color: "#825FFF",
        },
      },
      {
        name: "Capacity 1 (T)",
        type: "line",
        yAxisIndex: 0,
        tooltip: {
          valueFormatter: function (value) {
            return value;
          },
        },
        data: aggData
          .filter((item) => item.format === formatState)
          .map((item) => roundOffNumber(item.cap1)),
        itemStyle: {
          color: "#FF7944",
        },
      },
      {
        name: "Capacity 2 (T)",
        type: "line",
        yAxisIndex: 0,
        tooltip: {
          valueFormatter: function (value) {
            return value;
          },
        },
        data: aggData
          .filter((item) => item.format === formatState)
          .map((item) => roundOffNumber(item.cap2)),
        itemStyle: {
          color: "#1F36C7",
        },
      },
      {
        name: "Capacity 3 (T)",
        type: "line",
        yAxisIndex: 0,
        tooltip: {
          valueFormatter: function (value) {
            return value;
          },
        },
        data: aggData
          .filter((item) => item.format === formatState)
          .map((item) => roundOffNumber(item.cap3)),
        itemStyle: {
          color: "#01B2FE",
        },
      },
    ],
  };

  return (
    <Stack gap={1}>
      <Paper
        sx={{
          height: "calc(48vh - 120px)",
          minHeight: "calc(48vh - 120px)",
          maxHeight: "calc(48vh - 120px)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Stack
          mt={1}
          gap={2}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            Scenario Comparison - Capacity
          </Typography>
          <Box
            sx={{
              width: 200,
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <SearchFilter
              value={formatState}
              setValue={setFormatState}
              options={formatOptions}
            />
          </Box>
        </Stack>
        <Box sx={{ width: "100%", flexGrow: 1 }}>
          <ReactECharts
            option={option}
            style={{ width: "100%", height: "100%" }}
            notMerge
          />
        </Box>
      </Paper>
      <Paper
        sx={{
          height: "calc(48vh - 120px)",
          minHeight: "calc(48vh - 120px)",
          maxHeight: "calc(48vh - 120px)",
        }}
      >
        <TableContainer sx={{ maxHeight: "100%" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{
                    py: 0,
                    top: 0,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#41C5FE",
                  }}
                >
                  Before
                </TableCell>
                <TableCell
                  colSpan={6}
                  sx={{
                    py: 0,
                    top: 0,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#41C5FE",
                  }}
                >
                  After
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={5}
                  sx={{
                    py: 0,
                    top: 25,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#C8D0FF",
                  }}
                >
                  Tool Output
                </TableCell>
                <TableCell
                  colSpan={2}
                  sx={{
                    py: 0,
                    top: 25,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#B7F5BA",
                  }}
                >
                  Scenario 1
                </TableCell>
                <TableCell
                  colSpan={2}
                  sx={{
                    py: 0,
                    top: 25,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#B7F5BA",
                  }}
                >
                  Scenario 2
                </TableCell>
                <TableCell
                  colSpan={2}
                  sx={{
                    py: 0,
                    top: 25,
                    position: "sticky",
                    height: 18,
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 11,
                    background: "#B7F5BA",
                  }}
                >
                  Scenario 3
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Format L2
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Month
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Demand (T)
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Original Capacity (T)
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  CU%
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Capacity 1 (T)
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  CU%
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Capacity 2 (T)
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  CU%
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Capacity 3 (T)
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#C5EAFB",
                    py: 0,
                    top: 50,
                    position: "sticky",
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  CU%
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {aggData
                .filter((item) => item.format === formatState)
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ borderBottom: "1px solid #ccc" }}>
                      {item.format}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {item.month}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {roundOffNumber(item.demand)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {roundOffNumber(item.cap)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {calculateCu(item.demand, item.cap)}%
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {roundOffNumber(item.cap1)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {calculateCu(item.demand, item.cap1)}%
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {roundOffNumber(item.cap2)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {calculateCu(item.demand, item.cap2)}%
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {roundOffNumber(item.cap3)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      {calculateCu(item.demand, item.cap3)}%
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Stack>
  );
}

// This is the page component that contain the root level data so that cross
// tab data access is possible and it contain all the tabs and common filters
// for all tabs.
function CapacitySimulation() {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const activeAccount = accounts[0];
  const userEmail = activeAccount.username;

  const { setLoading, demandFile, simulationFilters, runtime, runtype } =
    useContext(LTCPContext);

  const [productTypeState, setProductTypeState] = useState("All");
  const [factoryState, setFactoryState] = useState(
    simulationFilters.factory[0]
  );
  const [currentTab, setCurrentTab] = useState("s1");
  const [productTypeOptions, setProductTypeOptions] = useState(
    simulationFilters.producttype
  );
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [orValue, setOrValue] = useState(1);
  const [originalData, setOriginalData] = useState([]);
  const [s1Data, setS1Data] = useState([]);
  const [s2Data, setS2Data] = useState([]);
  const [s3Data, setS3Data] = useState([]);
  const [g1Data, setG1Data] = useState([]);
  const [g2Data, setG2Data] = useState([]);
  const [g3Data, setG3Data] = useState([]);
  const [savedData1, setSavedData1] = useState([]);
  const [savedData2, setSavedData2] = useState([]);
  const [savedData3, setSavedData3] = useState([]);

  const [disableFilter, setDisableFilter] = useState(false);

  function onSaveHandler() {
    setDisableFilter(true);

    if (currentTab === "s1") {
      setSavedData1([...s1Data]);
    } else if (currentTab === "s2") {
      setSavedData2([...s2Data]);
    } else if (currentTab === "s3") {
      setSavedData3([...s3Data]);
    }
  }

  function onResetHandler() {
    setSavedData1([]);
    setSavedData2([]);
    setSavedData3([]);

    setDisableFilter(false);
  }

  async function fetchData() {
    setLoading(true);

    const resp = await Promise.all([
      getSimulationLineSpeed({
        demand_file: demandFile,
        product_type: productTypeState,
        factory: factoryState,
        runtime,
        runtype,
      }),
      getSimulationLineSpeedOR({
        demand_file: demandFile,
        product_type: productTypeState,
        factory: factoryState,
        runtime,
        runtype,
      }),
      getSimulationFilters(userEmail, {
        demand_file: demandFile,
        product_type: productTypeState,
        factory: factoryState,
        runtime,
        runtype,
      }),
    ]);

    setOriginalData(resp[0]);
    setS1Data(resp[0].map((item) => ({ ...item })));
    setS2Data(resp[0].map((item) => ({ ...item })));
    setS3Data(resp[0].map((item) => ({ ...item })));
    setOrValue(resp[1].or);
    setProductTypeOptions(resp[2].producttype);

    const result = resp[0];

    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [productTypeState, factoryState]);

  return (
    <Stack px={4} pt={3} pb={2} gap={1} flexGrow={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" gap={2} alignItems="center">
          <IconButton onClick={() => navigate(-1)}>
            <KeyboardBackspaceIcon />
          </IconButton>
          <Typography fontWeight="bold" fontSize={21}>
            Capacity Simulation
          </Typography>
        </Stack>
        <Stack direction="row" gap={2} alignItems="center">
          <Button
            size="small"
            variant="contained"
            onClick={onResetHandler}
            disabled={
              currentTab === "sc" ||
              (savedData1.length === 0 &&
                savedData2.length === 0 &&
                savedData3.length === 0)
            }
          >
            Refresh
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={onSaveHandler}
            disabled={
              currentTab === "sc" ||
              (currentTab === "s1" && savedData1.length > 0) ||
              (currentTab === "s2" && savedData2.length > 0) ||
              (currentTab === "s3" && savedData3.length > 0)
            }
          >
            Save
          </Button>
        </Stack>
      </Stack>
      <Paper>
        <Stack p={1} gap={2} direction="row" alignItems="center">
          <Stack sx={{ flexGrow: 1 }}>
            <Typography fontSize={14}>Product Type</Typography>
            <MultiSearchFilter
              disabled={disableFilter}
              filterName="producttype"
              value={productTypeState}
              setValue={setProductTypeState}
              options={productTypeOptions}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
            />
          </Stack>
          <Stack sx={{ flexGrow: 1 }}>
            <Typography fontSize={14}>
              Factory<span style={{ color: "red" }}>*</span>
            </Typography>
            <SearchFilter
              value={factoryState}
              setValue={setFactoryState}
              options={simulationFilters.factory}
              disabled={disableFilter}
            />
          </Stack>
        </Stack>
      </Paper>
      <Stack
        direction="row"
        gap={1}
        flexGrow={1}
        maxWidth="1000px"
        borderBottom="1px solid #ccc"
        height="32px"
        maxHeight="32px"
      >
        <Typography
          p={0.5}
          flexGrow={1}
          fontSize={14}
          textAlign="center"
          onClick={() => setCurrentTab("s1")}
          borderBottom={currentTab === "s1" ? "2px solid #1F36C7" : "none"}
          sx={{ cursor: "pointer" }}
        >
          Scenario 1
        </Typography>
        <Typography
          p={0.5}
          flexGrow={1}
          fontSize={14}
          textAlign="center"
          onClick={() => setCurrentTab("s2")}
          borderBottom={currentTab === "s2" ? "2px solid #1F36C7" : "none"}
          sx={{ cursor: "pointer" }}
        >
          Scenario 2
        </Typography>
        <Typography
          p={0.5}
          flexGrow={1}
          fontSize={14}
          textAlign="center"
          onClick={() => setCurrentTab("s3")}
          borderBottom={currentTab === "s3" ? "2px solid #1F36C7" : "none"}
          sx={{ cursor: "pointer" }}
        >
          Scenario 3
        </Typography>
        <Typography
          p={0.5}
          flexGrow={1}
          fontSize={14}
          textAlign="center"
          onClick={() => setCurrentTab("sc")}
          borderBottom={currentTab === "sc" ? "2px solid #1F36C7" : "none"}
          sx={{ cursor: "pointer" }}
        >
          Scenario Comparison
        </Typography>
      </Stack>
      {currentTab === "sc" && (
        <ScenarioComparison
          s1Data={savedData1}
          s2Data={savedData2}
          s3Data={savedData3}
          originalData={originalData}
          orValue={orValue}
        />
      )}
      {currentTab === "s1" && (
        <Scenario
          key="s1"
          name="s1"
          product_type={productTypeState}
          factory={factoryState}
          orValue={orValue}
          allData={s1Data}
          setAllData={setS1Data}
          graphData={g1Data}
          setGraphData={setG1Data}
          readOnly={savedData1.length > 0}
          currentProductType={
            productTypeState !== "All"
              ? productTypeState
              : productTypeOptions.length === 1
              ? productTypeOptions[0]
              : "All"
          }
          runType = {runtype}
        />
      )}
      {currentTab === "s2" && (
        <Scenario
          key="s2"
          name="s2"
          product_type={productTypeState}
          factory={factoryState}
          orValue={orValue}
          allData={s2Data}
          setAllData={setS2Data}
          graphData={g2Data}
          setGraphData={setG2Data}
          readOnly={savedData2.length > 0}
          runType = {runtype}
        />
      )}
      {currentTab === "s3" && (
        <Scenario
          key="s3"
          name="s3"
          product_type={productTypeState}
          factory={factoryState}
          orValue={orValue}
          allData={s3Data}
          setAllData={setS3Data}
          graphData={g3Data}
          setGraphData={setG3Data}
          readOnly={savedData3.length > 0}
          runType = {runtype}
        />
      )}
    </Stack>
  );
}

export default CapacitySimulation;
